import React from 'react'
import classNames from 'classnames'

import * as Icons from 'components/Utils/Icons'

import { UserAvatar } from 'components/Utils/Avatar'
import { Text } from 'components/base'

function PingAction({ isNudged, isHovered, isFocused }) {
  if (!(isNudged || isHovered || isFocused)) {
    return null
  }
  return (
    <div className="font-weight-bold font-size-small flexbox flexbox-align-center primary margin-left-small">
      <div className={classNames('margin-right-normal', {})}>
        {isNudged ? 'pinged!' : 'ping'}
      </div>
      <Icons.NudgeIcon
        size={16}
        className={classNames({
          'nudge-in': isNudged,
        })}
      />
    </div>
  )
}

const UserItem = React.memo(
  ({ user, hasAccess, isNudged = false, isFocused = false, nudge, style }) => {
    const [isHovered, setIsHovered] = React.useState(false)

    const onClick = React.useCallback(
      () => {
        if (!hasAccess) {
          return
        }
        nudge(user)
      },
      [hasAccess, user, nudge]
    )

    return (
      <div
        style={style}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className={classNames(
            'no-outline',
            'flexbox flexbox-align-center',
            'padding-small margin-smaller',
            'radius-normal',
            {
              'pointer background-shade-50-on-hover': hasAccess,
              'background-shade-50': isFocused,
            }
          )}
        >
          <UserAvatar
            size="small"
            className="margin-right-small"
            userId={user.id}
          />
          <div className="flexbox-grow flexbox flexbox-align-center ellipsis">
            <Text.Name className="margin-right-small">
              @{user.username}
            </Text.Name>
            <Text.Detail className="ellipsis">
              {hasAccess ? user.displayName : 'Not in channel'}
            </Text.Detail>
          </div>
          {hasAccess && (
            <PingAction
              isNudged={isNudged}
              isHovered={isHovered}
              isFocused={isFocused}
            />
          )}
        </div>
      </div>
    )
  }
)

export default UserItem
